import { useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { observer } from 'mobx-react-lite';

import PaymentButtons from '../payment-buttons';
import PaypalButton from '../paypal-button';

import paymentStore from 'src/stores/payment-store';

import useSluggedNavigate from 'src/hooks/use-slugged-navigate';
import { AppRoute, PaymentType, PAYPAL_CLIENT_ID } from 'src/constants';
import type { PaypalFormProps } from './paypal-form.props';

const PaypalForm = observer(({ form }: PaypalFormProps) => {
  const navigate = useSluggedNavigate();
  const orderNoRef = useRef<string>();

  const handlePaypalPayment = useCallback(async () => {
    const result = await paymentStore.createOrder(PaymentType.PAYPAL);
    orderNoRef.current = result.no;
    paymentStore.setPaymentLoading(false);
    return result;
  }, []);

  const handlePaypalSuccess = useCallback(() => {
    const orderNo = orderNoRef.current;
    if (orderNo) {
      paymentStore.setPaidOrderNumber(orderNo);
      navigate(`${AppRoute.PAYMENT_RESULT_PAGE_ROUTE}/${orderNo}`);
    }
  }, [navigate]);

  return (
    <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID, disableFunding: 'credit,card' }}>
      <PaypalButton
        onCreateOrder={handlePaypalPayment}
        onError={paymentStore.setPaymentFormError}
        onSuccess={handlePaypalSuccess}
      />
      {createPortal(<PaymentButtons />, form)}
    </PayPalScriptProvider>
  );
});

export default PaypalForm;
